const signatureId = signature => `${signature.user_id}/${signature.date}`;

export default signatureId;
